// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "20261005.1791213855/static/js/" + chunkId + "." + {"249":"546b2f18","463":"8a875d0b"}[chunkId] + ".chunk.js";
};